import { createSlice } from "@reduxjs/toolkit";
import { IMediaContentSlice } from "../../../models/master/mediaContent";


const initialMediaContentState: IMediaContentSlice = {
  mediaContents:undefined,
  mediaContent:undefined
};

const mediaContentSlice = createSlice({
  name: "mediaContent",
  initialState: initialMediaContentState,
  reducers: {
    setMediaContents: (state, action: { payload: any }) => {
      state.mediaContents = action.payload;
    },
    setMediaContent: (state, action: { payload: any }) => {
      state.mediaContent = action.payload;
    },
    
  },
});

export const { setMediaContents, setMediaContent } =
mediaContentSlice.actions;

const mediaContentReducer = mediaContentSlice.reducer;

export type technologyResourceState = ReturnType<typeof mediaContentReducer>;

export default mediaContentReducer;
